import { Formik, Form } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { FormTextAreaField } from "../../components/form/text-area";
import { FormImageField } from "../../components/form/image";
import { FormMultiImageField } from "../../components/form/multi-image";
import { FormDropDown } from "../../components/form/dropdown";
import { useEffect } from "react";
import { useState } from "react";
import { api } from "../../redux/apis/api";

const CreateProduct = () => {
  const naviagte = useNavigate();
  const [userList, setuserList] = useState([]);

  const initialValues = {
    name: "",
    price: "",
    description: "",
    photo_url: "",
    photos: [],
    hsn_code: "",
    cgst: "",
    sgst: "",
    igst: "",
    status: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/product/create`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/product/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const statusOptions = [
    {
      label: "Active",
      value: "active",
    },
    {
      label: "Inactive",
      value: "inactive",
    },
    {
      label: "Draft",
      value: "draft",
    },
  ];

  const fetchUserDropDownData = () => {
    api
      .get(`/ffadmin/user-list-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.users?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setuserList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchUserDropDownData();
  }, []);

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                <h2 className="text-xl font-semibold capitalize">
                  product - Create
                </h2>
                <div className="flex gap-3 items-center">
                  <button
                    onClick={() => naviagte("/product/list")}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Create
                  </button>
                </div>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormTextField
                    name={"name"}
                    label={"product name"}
                    placeholder={`Enter product name`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"price"}
                    label={"product price"}
                    placeholder={`Enter product price`}
                  />
                </div>
                <div className="my-4">
                  <FormTextAreaField
                    name={"description"}
                    label={"product description"}
                    placeholder={`Enter product description`}
                    rows={3}
                  />
                </div>
                <div className="my-4">
                  <FormImageField name={"photo_url"} label={"photo url"} />
                </div>
                <div className="my-4">
                  <FormMultiImageField name={"photos"} label={"photos"} />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"hsn_code"}
                    label={"product hsn code"}
                    placeholder={`Enter product hsn code`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"cgst"}
                    label={"product cgst"}
                    placeholder={`Enter product cgst`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"sgst"}
                    label={"product sgst"}
                    placeholder={`Enter product sgst`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"igst"}
                    label={"product igst"}
                    placeholder={`Enter product igst`}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name="status"
                    label="status"
                    options={statusOptions}
                    menuPlacement="top"
                  />
                </div>
              </section>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default CreateProduct;
